import React, { useEffect, useState } from 'react'
import { useStyles } from './CoursEnLigneStyle'
import Cour from '../../components/Cour/Cour'

//Material UI
import Card from '@material-ui/core/Card'
import Skeleton from '@material-ui/lab/Skeleton'
import MenuItem from '@material-ui/core/MenuItem'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import CardHeader from '@material-ui/core/CardHeader'
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined'

const data = [
  {
    id: '1',
    nom: 'Danse',
    seances: [
      {
        id: '1',
        date: '19/03/2021',
        videoLink: `https://youtube.com/Danse/1`,
      },
      {
        id: '2',
        date: '22/03/2021',
        videoLink: `https://youtube.com/Danse/2`,
      },
      {
        id: '3',
        date: '27/03/2021',
        videoLink: `https://youtube.com/Danse/3`,
      },
    ],
  },
  {
    id: '2',
    nom: 'Judo',
    seances: [
      {
        id: '1',
        date: '19/03/2021',
        videoLink: `https://youtube.com/Judo/1`,
      },
      {
        id: '2',
        date: '22/03/2021',
        videoLink: `https://youtube.com/Judo/2`,
      },
    ],
  },
  {
    id: '3',
    nom: 'Karate',
    seances: [
      {
        id: '1',
        date: '19/03/2021',
        videoLink: `https://youtube.com/Karate/1`,
      },
    ],
  },
]

export default function CoursEnLigne() {
  const classes = useStyles()
  const [cours, setCours] = useState([])
  const [selectedCour, setSelectedCour] = useState({})

  const handleSelect = (e) => {
    setSelectedCour(e)
  }

  // Récupère les cours à l'arrivé sur la page
  useEffect( () => {
    async function fetchApi(){
      const c = await getCoursEnLigne()
      setCours(c)
      setSelectedCour(c[0])
    } 
    fetchApi()
        
  }, [])

  const getCoursEnLigne = () => {
    return new Promise((res) => {
      setTimeout(() => {
        res(data)
      }, 500)
    })
  }

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <Grid container>
          <Grid item xs={2}>
            <Paper elevation={1} className={classes.paper} square>
              <CardHeader
                className={classes.cardHeader}
                title={
                  <div>
                    <NoteOutlinedIcon
                      className={classes.icon}
                    />
                    <span className={classes.menuTitle}>
                                            Mes cours
                    </span>
                  </div>
                }
              />
              <div className={classes.cont}>
                {cours.map((a, i) => (
                  <MenuItem
                    selected={a === selectedCour}
                    id={i}
                    className={classes.menuItem}
                    onClick={() => handleSelect(a)}
                  >
                    {a.nom}
                  </MenuItem>
                ))}
              </div>
            </Paper>
          </Grid>

          <Grid item xs={10}>
            <h2 className={classes.title}>Mes cours en ligne</h2>
            <div className={classes.cont + ' ' + classes.right}>
              {selectedCour &&
                            selectedCour?.seances &&
                            selectedCour?.seances.length > 0 ? (
                  selectedCour?.seances.map((a, i) => (
                    <Cour
                      nom={selectedCour.nom}
                      id={a.id}
                      date={a.date}
                      videoLink={a.videoLink}
                      key={i}
                    />
                  ))
                ) : (
                  <div className={classes.skelets}>
                    <Skeleton variant="rect" height={100} />
                    <Skeleton variant="rect" height={100} />
                    <Skeleton variant="rect" height={100} />
                  </div>
                )}
            </div>
          </Grid>
        </Grid>
      </Card>
    </div>
  )
}
